interface NamedItem {
  name?: string;
}

interface VehicleParts {
  year?: number | string | null;
  brand?: NamedItem | null;
  model?: NamedItem | null;
  version?: NamedItem | null;
}

export const describeVehicle = ({ year, brand, model, version }: VehicleParts): string => {
  const parts = [year, brand?.name, model?.name, version?.name].filter(Boolean);
  return parts.join(' ') || 'Vehículo';
};

export const formatPrice = (value: number | undefined | null): string => {
  if (value === null || value === undefined) return '$0.00';
  return new Intl.NumberFormat('es-MX', {
    style: 'currency',
    currency: 'MXN',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
};
